import { Megaphone, TrendingUp, Users } from "lucide-react";
import ContactDialog from "@/components/ContactDialog";

export default function BonusPubblicita() {
  return (
    <section data-testid="bonus-pubblicita-section" className="max-w-7xl mx-auto px-4 my-14">
      <div className="relative overflow-hidden rounded-sm border-2 border-legend-red bg-white dark:bg-legend-paper">
        <div className="checkered absolute top-0 right-0 h-full w-32 opacity-10" />
        <div className="p-8 md:p-12 relative">
          <span className="inline-flex items-center gap-2 bg-legend-yellow text-legend-ink font-mono uppercase text-xs tracking-widest px-3 py-1 rounded-sm mb-4">
            <Megaphone size={14} /> Bonus Pubblicità
          </span>
          <h2 className="font-display font-black uppercase text-3xl md:text-5xl leading-none mb-4 max-w-3xl">
            Vuoi promuovere la tua azienda con Legend Magazine?
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed max-w-2xl mb-8">
            Porta il tuo brand
            davanti a migliaia di appassionati di rally e motorsport. Spazi pubblicitari in home page, banner negli articoli
            e visibilità sui nostri canali ufficiali.
          </p>
          <div className="grid sm:grid-cols-3 gap-4 mb-8">
            {[
              { icon: Users, t: "Pubblico Targettizzato", d: "Appassionati di rally e motorsport" },
              { icon: TrendingUp, t: "Visibilità Multicanale", d: "Web + social ufficiali" },
              { icon: Megaphone, t: "Formati Flessibili", d: "Banner, articoli e loghi pubblicitari" },
            ].map((b, i) => (
              <div key={i} className="flex items-start gap-3 p-4 rounded-sm bg-slate-50 dark:bg-white/5">
                <b.icon size={22} className="text-legend-red mt-0.5" />
                <div>
                  <p className="font-display font-bold uppercase text-sm">{b.t}</p>
                  <p className="text-xs text-slate-500">{b.d}</p>
                </div>
              </div>
            ))}
          </div>
          <ContactDialog
            kind="sponsor"
            title="Diventa Inserzionista"
            trigger={
              <button data-testid="bonus-pubblicita-cta" className="inline-flex items-center gap-2 bg-legend-red hover:bg-legend-dark text-white font-bold uppercase tracking-wide px-6 py-3 rounded-sm transition-colors">
                Richiedi il Media Kit & Listino Pubblicità
              </button>
            }
          />
        </div>
      </div>
    </section>
  );
}
